import { useState, useEffect } from 'react';
import { AxiosError } from 'axios';

// Api
import { GetLatestVideo } from "../../../../Api/Video";

// Models
import VideoDTO from "../../../../Models/DTOs/VideoDTO";

export default function useFetchLatestEpisode(seriesId: number) {

    const
        [latest, setLatest] = useState<VideoDTO | null>(null),
        [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!seriesId) return;

        let ac = new AbortController();
        setLoading(true);

        GetLatestVideo(seriesId, ac)
            .then(res => {
                if (!(res instanceof AxiosError)) setLatest(res);
            })
            .finally(() => setLoading(false));

        return () => ac.abort();
    }, [seriesId]);

    return { latest, loading };
}
